import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

export const ROLE_QUALITY_MANAGER = 'quality-manager';
export const ROLE_ADMIN = 'admin';

/**
 * Resolve app role from signed-in email using allowlisted env emails.
 * @param {string | null | undefined} email
 * @returns {'quality-manager' | 'admin' | null}
 */
export function resolveRoleFromEmail(email) {
  if (!email) return null;
  const normalized = email.trim().toLowerCase();
  const qmEmail = (process.env.REACT_APP_QM_EMAIL || '').trim().toLowerCase();
  const adminEmail = (process.env.REACT_APP_ADMIN_EMAIL || '').trim().toLowerCase();

  if (qmEmail && normalized === qmEmail) return ROLE_QUALITY_MANAGER;
  if (adminEmail && normalized === adminEmail) return ROLE_ADMIN;
  return null;
}
